import React from "react";
import ComingSoon from "./ComingSoon";

const Broker = () => <ComingSoon title="Broker" />;

export default Broker;
